var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { okta } from '@auth0/quantum-tokens';
import { createTheme } from './create-theme';
export var createQuantumTheme = function (_a) {
    var _b = _a.tokens, tokens = _b === void 0 ? okta : _b, themeOptions = _a.themeOptions;
    var light = createTheme(__assign(__assign({}, themeOptions), { tokens: tokens.light, palette: __assign({ mode: 'light' }, themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.palette) }));
    var dark = createTheme(__assign(__assign({}, themeOptions), { tokens: tokens.dark, palette: __assign({ mode: 'dark' }, themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.palette) }));
    return {
        dark: dark,
        light: light,
    };
};
